const formRows = [
  {
    span: 12,
    label: '名称',
    component: 'AInput',
    placeholder: '请输入服务名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 12,
    label: '邮箱',
    component: 'AInput',
    placeholder: '请输入邮箱',
    prop: 'email',
    allowClear: true
  },
  {
    span: 12,
    label: '手机号',
    component: 'AInput',
    placeholder: '请输入手机号',
    prop: 'phone',
    allowClear: true
  },
  {
    span: 12,
    label: '专家类型',
    component: 'ASelect',
    placeholder: '请输入专家类型',
    prop: 'expertsType',
    allowClear: true,
    list: [
      { label: '知识产权专家', value: '1' },
      { label: '专业技术专家', value: '2' }
    ]
  },
  {
    span: 24,
    label: '行业',
    component: 'ARadioGroup',
    prop: 'industry',
    placeholder: '请选择行业类型',
    radioList: [
      { label: '代理服务', value: '1' },
      { label: '法律状态', value: '2' },
      { label: '咨询服务', value: '3' },
      { label: '信息服务', value: '4' },
      { label: '企业管理', value: '5' }
    ]
  },
  {
    span: 24,
    label: '照片',
    component: 'AUpload',
    prop: 'picPath' // 首图
  },
  {
    span: 24,
    label: '简介',
    component: 'ATextArea',
    placeholder: '请输入简介',
    prop: 'introduction',
    style: {
      height: '78px'
    },
    row: 5,
    allowClear: true
  },
  {
    span: 24,
    label: '专家介绍',
    component: 'RichTextEdit',
    prop: 'info'
  }
]
var reg = new RegExp(
  '^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$'
) // 校验手机号
const formRules = {
  name: [
    { required: true, message: '名称不能为空', trigger: 'blur' },
    { min: 1, max: 100, message: '输入的字数不能超过100个', trigger: 'blur' }
  ],
  phone: [
    // { required: true, message: '电话号码不能为空', trigger: ['blur'] },
    {
      validator: (rule, val, callback) => {
        if (!val) return callback()
        if (!reg.test(val)) {
          callback(new Error('请输入正确的手机号!'))
        } else {
          callback()
        }
      }
    }
  ],
  email: [{ type: 'email', message: '请输入正确的邮箱!' }],
  industry: [{ required: true, message: '行业不能为空', trigger: ['blur'] }],
  expertsType: [
    { required: true, message: '专家类型不能为空', trigger: ['blur'] }
  ],
  area: [{ required: true, message: '区域不能为空', trigger: ['blur'] }],
  introduction: [
    { required: true, message: '简介不能为空', trigger: ['blur'] }
  ],
  picPath: [{ required: true, message: '配图不能为空', trigger: ['blur'] }],
  info: [{ required: true, message: '专家介绍不能为空', trigger: ['blur'] }]
}

const formInfo = [
  { label: '名称', value: '-', key: 'name' },
  { label: '邮箱', value: '-', key: 'email' },
  { label: '手机号', value: '-', key: 'phone' },
  { label: '专家类型', value: '-', key: 'expertsTypeStr' },
  { label: '行业', value: '-', key: 'industryStr' },
  { label: '照片', value: '-', key: 'picture', isVHtml: true },
  { label: '简介', value: '-', key: 'introduction' },
  { label: '专家介绍', value: '-', key: 'info', isVHtml: true }
]

module.exports = {
  formRows,
  formRules,
  formInfo
}
